/* eslint-disable no-alert */
import { Box, Button, TextField, Typography } from '@mui/material';
import Card from '@src/main/ui/components/common/Card/Card';
import Modal from '@src/main/ui/components/common/Modal/Modal';
import { useAreaContext } from '@src/main/ui/providers/area/AreaContextProvider';
import React, { useState, type FC } from 'react';
import { useParams } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import { v4 as uuidv4 } from 'uuid';

interface Props {
  id: string | null;
  name: string;
  onClose: () => void;
}

const AdminAddDashboardAreaModal: FC<Props> = ({ id, name, onClose }) => {
  const [nameInput, setNameInput] = useState(name);
  const [loadingSave, setLoadingSave] = useState(false);
  const { areaId, subareaId } = useParams();
  const { addArea } = useAreaContext();

  const submit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoadingSave(true);
    const idItem = id || uuidv4();
    addArea({
      name: nameInput,
      areaId,
      subareaId: subareaId || idItem,
      subsubareaId: subareaId ? idItem : undefined,
    })
      .then(() => onClose())
      .catch(() => alert('Insufficient permissions for adding the area'))
      .finally(() => setLoadingSave(false));
  };

  return (
    <>
      <Modal open handleClose={onClose}>
        <Card width="90vw" maxWidth="450px" maxHeight="75vh">
          <form onSubmit={submit}>
            <Box
              sx={{
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                gap: '20px',
              }}
            >
              <Typography variant="h5">{name === '' ? 'Add' : 'Edit'} area</Typography>
              <TextField
                sx={{
                  width: '100%',
                }}
                value={nameInput}
                variant="standard"
                label="Name"
                onChange={(e) => setNameInput(e.target.value)}
              />
              <Button
                sx={{
                  width: 'fit-content',
                  alignSelf: 'flex-end',
                }}
                color="secondary"
                variant="contained"
                type="submit"
                disabled={loadingSave}
              >
                {name === '' ? 'Add' : 'Save'}
              </Button>
            </Box>
          </form>
        </Card>
      </Modal>
    </>
  );
};

export default AdminAddDashboardAreaModal;
